<script setup lang="ts">
interface LoaderProps {
  size?: 'small' | 'medium' | 'large' | 'big' | 'ultra'
}

const props = withDefaults(defineProps<LoaderProps>(), {
  size: 'small',
})
</script>
<template>
  <div
    class="spinner"
    :class="`spinner_size_${props.size}`"
  >
    <div
      v-for="i in 12"
      :key="i"
      class="spinner_blade"
    ></div>
  </div>
</template>

<style lang="scss" scoped>
.spinner {
  --size: 1rem;
  --color: var(--clr-black-6);

  transition: 0.22s;
  font-size: var(--size);
  position: relative;
  display: inline-block;
  width: 1em;
  height: 1em;

  &_size {
    &_small {
      --size: 1rem;
    }
    &_medium {
      --size: 1.5rem;
    }
    &_large {
      --size: 2rem;
    }
    &_big {
      --size: 3rem;
    }
    &_ultra {
      --size: 4rem;
    }
  }

  &_blade {
    position: absolute;
    left: 0.4em;
    bottom: 0em;
    width: 0.2em;
    height: 0.2em;
    border-radius: 50%;
    transform-origin: center -150%;
    animation: spinner-fade 1s infinite linear;

    background-color: var(--color);
    opacity: 0.1;

    $animation-delay: 0s;
    $blade-rotation: 0deg;

    @for $i from 1 through 12 {
      &:nth-child(#{$i}) {
        animation-delay: $animation-delay;
        transform: rotate($blade-rotation);
        $blade-rotation: $blade-rotation + 30;
        $animation-delay: $animation-delay + 0.083;
      }
    }
  }
}

@keyframes spinner-fade {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.1;
  }
}
</style>
